// LICENSE_CODE MIT
/* eslint-disable */
export default {
  "sentry": {
    "front": {
      "dsn": "xxx"
    },
    "back": {
      "dsn": "yyy"
    }
  },
  "auth0": {},
  "sbase": {},
  "front": {
    "company_lbl": "Example",
    "url": "https://bstage.io",
    "email": "support@bstage.io",
    "phone": "+1888555555",
    "addr_lbl": "Example st. 57, Region, Country, 4138910"
  },
  "back": {
    "app": {
      "url": "https://api.bstage.io"
    },
    "api": {
      "url": "https://api.bstage.io"
    },
    "media": {
      "url": "https://backstage.erate.co.il"
    }
  },
  "domain": "bstage.io",
  "is_prod": true,
  "ver": "1.0.2",
  "is_local": false,
  "stage": "prod",
  "bucket_ext": "bs-front-share-prod"
}